import React, { useEffect, useState } from "react";
import { getAuditLogs } from "../api"; 
import { toast } from "react-toastify";

const AuditDashboardPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  // Filter State
  const [filters, setFilters] = useState({
    actor: "",
    action: "",
    entity: "",
    ip: "", 
    details: "",
    date: ""
  });

  useEffect(() => {
    fetchLogs();
  }, []);

  // Reset pagination to page 1 whenever filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  const fetchLogs = () => {
    getAuditLogs()
      .then((res) => {
        setLogs(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching audit logs:", err);
        toast.error("Failed to load audit logs");
        setLoading(false);
      });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  // 1. Apply Filters
  const filteredLogs = logs.filter(log => {
    const actorStr = log.actorName 
      ? log.actorName.toLowerCase() 
      : (log.actor_user_id ? log.actor_user_id.toString() : "system");
      
    const actionStr = log.action ? log.action.toLowerCase() : "";
    const entityStr = log.entity ? log.entity.toLowerCase() : "";
    const ipStr = log.ip ? log.ip.toLowerCase() : "";
    const metaStr = log.meta ? log.meta.toLowerCase() : "";
    const dateStr = log.created_at ? new Date(log.created_at).toLocaleString().toLowerCase() : "";

    return (
      actorStr.includes(filters.actor.toLowerCase()) &&
      actionStr.includes(filters.action.toLowerCase()) &&
      entityStr.includes(filters.entity.toLowerCase()) &&
      ipStr.includes(filters.ip.toLowerCase()) && 
      metaStr.includes(filters.details.toLowerCase()) &&
      dateStr.includes(filters.date.toLowerCase())
    );
  });

  // 2. Apply Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentLogs = filteredLogs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredLogs.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(prev => prev - 1);
  };

  // --- STYLES INJECTION ---
  const PageStyleBlock = () => (
    <style>{`
      .ad-input {
          border: 1px solid #e1e4e8;
          border-radius: 4px;
          padding: 6px 10px;
          width: 100%;
          font-size: 0.85rem;
          outline: none;
      }
      .ad-input:focus {
          border-color: #20c997;
          box-shadow: 0 0 0 2px rgba(32, 201, 151, 0.1);
      }
      .ad-table th {
          background-color: #f8f9fa;
          color: #636e72;
          font-weight: 600;
          padding: 12px;
          border-bottom: 2px solid #e1e4e8;
          font-size: 0.9rem;
      }
      .ad-table td {
          padding: 12px;
          border-bottom: 1px solid #e1e4e8;
          font-size: 0.85rem;
          vertical-align: middle;
          color: #2d3436;
      }
      .ad-table tr:hover { background-color: #fcfcfc; }
      
      /* Pagination Buttons */
      .page-btn {
          background-color: #fff;
          border: 1px solid #e1e4e8;
          color: #2d3436;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 0.85rem;
          transition: all 0.2s;
      }
      .page-btn:hover:not(:disabled) {
          background-color: #f0fdf9;
          border-color: #20c997;
          color: #20c997;
      }
      .page-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          background-color: #f8f9fa;
      }
    `}</style>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      <PageStyleBlock />

      {/* Top Header */}
      

      <div style={styles.wrapper}>
        
        {/* Card Container with Teal Border */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#2d3436' }}>Audit logs</h4>
            <h4 style={{ color: '#636e72', fontSize: '0.9rem' }}>
              Total Logs: <strong>{filteredLogs.length}</strong>
            </h4>
             

          </div>
          
          <div style={{ overflowX: 'auto' }}>
            {loading ? (
              <div style={{ padding: '40px', textAlign: 'center', color: '#636e72' }}>Loading logs...</div>
            ) : (
              <>
                <table className="ad-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{minWidth: '150px'}}>
                        <input type="text" className="ad-input" placeholder="Filter Actor..." name="actor" value={filters.actor} onChange={handleFilterChange} />
                      </th>
                      <th style={{minWidth: '120px'}}>
                        <input type="text" className="ad-input" placeholder="Filter Action..." name="action" value={filters.action} onChange={handleFilterChange} />
                      </th>
                      <th style={{minWidth: '150px'}}>
                          <input type="text" className="ad-input" placeholder="Filter Entity..." name="entity" value={filters.entity} onChange={handleFilterChange} />
                      </th>
                      <th style={{minWidth: '130px'}}>
                          <input type="text" className="ad-input" placeholder="Filter IP..." name="ip" value={filters.ip} onChange={handleFilterChange} />
                      </th>
                      <th>
                          <input type="text" className="ad-input" placeholder="Search Details..." name="details" value={filters.details} onChange={handleFilterChange} />
                      </th>
                      <th style={{minWidth: '180px'}}>
                          <input type="text" className="ad-input" placeholder="Filter Date..." name="date" value={filters.date} onChange={handleFilterChange} />
                      </th>
                    </tr>
                    <tr>
                      <th>Actor</th>
                      <th>Action</th>
                      <th>Entity</th>
                      <th>IP Address</th>
                      <th>Details</th>
                      <th>Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentLogs.length > 0 ? (
                      currentLogs.map((log) => (
                        <tr key={log.id}>
                          <td>
                            {log.actorName ? (
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <span style={{ fontWeight: '600', color: '#007bff' }}>{log.actorName}</span>
                                  <small style={{ color: '#999' }}>ID: {log.actor_user_id}</small>
                                </div>
                              ) : (
                                <span style={{ 
                                    backgroundColor: log.actor_user_id ? '#e2e6ea' : '#f8f9fa', 
                                    padding: '4px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 'bold', color: '#636e72' 
                                }}>
                                  {log.actor_user_id ? `User: ${log.actor_user_id}` : "System"}
                                </span>
                              )}
                          </td>
                          <td style={{ fontWeight: '600', textTransform: 'uppercase', fontSize: '0.8rem' }}>
                            {log.action}
                          </td>
                          <td>
                              {log.entity} <small style={{ color: '#999' }}>(#{log.entity_id})</small>
                          </td>
                          <td style={{ fontFamily: 'monospace', color: '#d63384' }}>
                              {log.ip || <span style={{ color: '#ccc' }}>-</span>}
                          </td>
                          <td style={{ maxWidth: "350px", wordWrap: "break-word" }}>
                              <code style={{ color: '#636e72', backgroundColor: '#f8f9fa', padding: '2px 4px', borderRadius: '4px' }}>{log.meta}</code>
                          </td>
                          <td style={{ color: '#636e72' }}>
                            {new Date(log.created_at).toLocaleString()}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: 'center', padding: '30px', color: '#999' }}>
                          No logs match your filters.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* ✅ Pagination Controls */}
                {filteredLogs.length > 0 && (
                  <div style={styles.paginationContainer}>
                    <div style={{ fontSize: '0.85rem', color: '#636e72' }}>
                        Showing <strong>{indexOfFirstItem + 1}</strong> to <strong>{Math.min(indexOfLastItem, filteredLogs.length)}</strong> of <strong>{filteredLogs.length}</strong> entries
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <button 
                            className="page-btn" 
                            onClick={handlePrevPage} 
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        <span style={{ fontSize: '0.85rem', margin: '0 8px' }}>
                            Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                        </span>
                        <button 
                            className="page-btn" 
                            onClick={handleNextPage} 
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  // Matches top-header style from other pages
  topHeader: {
    backgroundColor: 'white',
    padding: '0 40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #e1e4e8',
    height: '70px',
    flexShrink: 0,
    zIndex: 10,
    position: 'sticky',
    top: 0
  },
  topHeaderTitle: {
    fontSize: '1.2rem',
    color: '#2d3436',
    margin: 0,
    fontWeight: '700',
  },
  wrapper: {
    padding: '30px',
    flexGrow: 1,
    overflowY: 'auto',
    backgroundColor: '#f0fdf9', // Teal Background
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.04)',
    borderTop: '5px solid #20c997', // ✅ TEAL BORDER
    overflow: 'hidden',
  },
  cardHeader: {
    padding: '20px 25px',
    borderBottom: '1px solid #e1e4e8',
    backgroundColor: 'white',
  },
  paginationContainer: {
    padding: '15px 25px',
    borderTop: '1px solid #e1e4e8',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
  }
};

export default AuditDashboardPage;